import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import home from "@/components/home";
import add from "@/components/add";
import informationview from "@/components/informationview";
import { getOrDestroy } from "../utils";
import { Message } from "element-ui";
Vue.use(Router);
const router = new Router({
    routes: [{
            path: "/",
            name: "login",
            meta: { title: "登录" },
            component: login
        },
        {
            path: "/home",
            name: "home",
            meta: { title: "首页" },
            component: home
        },
        {
            path: "/informationview",
            name: "informationview",
            meta: { title: "信息查看" },
            component: informationview
        },

        {
            path: "/add",
            name: "add",
            meta: { title: "信息添加/修改" },
            component: add
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    var flag = getOrDestroy("loginStatus", 1);
    if (to.name !== "login") {
        // 非登录页,判断登录状态
        if (flag) {
            from.name === "login" &&
                to.name === "home" &&
                Message.info({
                    message: "欢迎使用商户信息管理系统",
                    showClose: true,
                    duration: 3000
                });
            next();
        } else {
            next({ path: "/" });
            Message.info({ message: "请登录", showClose: true, duration: 3000 });
        }
    } else {
        next(); // 登录页不拦截
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js